<template>
  <Menu :theme="'light'" :active-name="activeMenu" accordion :width="'220px'" @on-select="turnUrl" :mode="mode">
    <MenuItem :name="item.name" v-for="(item) in menus" :key="item.name"><i class="iconfont"
                                                                            :class="'icon-'+item.meta.icon"
                                                                            v-if="item.meta.icon"></i>
      {{item.meta.title }}
    </MenuItem>
  </Menu>
</template>

<script>
/**
  * @name  (组件名称)
  * @module 组件存放位置
  * @desc 组件描述
  * @author Jacke
  * @date
  * @param {Object} [title]    - 参数说明
  * @param {String} [columns] - 参数说明
  * @example 调用示例
  *  <></>
  */

import {oneOf} from "view-design/src/utils/assist.js";

export default {
  name: 'SideBar',
  components: {},
  props: {
    menus: {
      type: Array,
      default: []
    },
    mode: {
      validator (value) {
        return oneOf(value, ['horizontal', 'vertical']);
      },
      default: 'vertical'
    },
    activeMenu: {
      type:String
    }
  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {

  },
  computed: {},
  // 监听,当路由发生变化的时候执行
  watch: {},
  methods: {
    turnUrl(name) {
      console.log(name)
      setTimeout(() => {
        try {
          this.$router.push({name})
        } catch (e) {
          console.log('err', e)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.lasp {
  width: 100%;
  display: flex;
  // display;
  .lasp-left {
    width: 220px;

    .ivu-menu-light {
      //background: transparent;
    }

    .ivu-menu {
      box-shadow: 14px 14px 15px 0 rgba(162, 172, 192, 0.1);
      // box-shadow: 14px 14px 15px 0 rgba(166,180,211,.2);
      // box-shadow: rgba(166,180,211,.2) 0 0 10px;
      border-radius: 12px;
      border: 0;
      margin: 5px;
      // overflow: hidden;
      // overflow: hidden;
    }

    .ivu-menu-item:hover {
      box-shadow: 14px 14px 15px 0 rgba(145, 154, 173, 0.2);
    }

    .ivu-menu-item-active {
      // box-shadow: 14px 14px 15px 0 rgba(145, 154, 173, 0.2);
      background: transparent;
    }

    .ivu-menu-item {
      display: flex;
      align-items: center;
    }

    .iconfont {
      margin-right: 9px;
      font-size: 16px;
    }
  }

  .lasp-right {
    width: 1180px;
    padding: 16px;
  }
}
</style>


<!-- [
            {
            title:'Home',
            url:'/lasp/home',
            name:'LaspHome'
          },
          {
            title:'LASP History',
            url:'/lasp/history',
            name:'LaspHistory'
          },
          {
            title:'Mannual',
            url:'/lasp/mannual',
            name:'LaspMannual'
          },
          {
            title:'Examples',
            url:'/lasp/examples',
            name:'LaspExamples'
          },
          {
            title:'NN Library',
            url:'/lasp/nnLibrary',
            name:'LaspNNLibrary'
          },
          {
            title:'LASP Download',
            url:'/lasp/download',
            name:'LaspDownload'
          },
          {
            title:'LASP Methodology',
            url:'/lasp/methodology',
            name:'LaspMethodology'
          },
          {
            title:'LASP Applications',
            url:'/lasp/applications',
            name:'LaspApplications'
          },
          {
            title:'LASP View',
            url:'/lasp/view',
            name:'LaspView'
          },
          {
            title:'LASP Tutorial',
            url:'/lasp/tutorial',
            name:'LaspTutorial'
          },
          {
            title:'LiuGroup at Fudan',
            url:'/lasp/liuGroupAtFudan',
            name:'LaspLiuGroupAtFudan'
          }
          ]

          [{
            title:'Home',
            url:'/introduce/home',
            name:'IntroduceHome'
          },
          {
            title:'Publications',
            url:'/introduce/publications',
            name:'IntroducePublications'
          },
          {
            title:'Research',
            url:'/introduce/research',
            name:'IntroduceResearch'
          },
          {
            title:'People',
            url:'/introduce/people',
             name:'IntroducePeople'
          },
          {
            title:'Courses',
            url:'/introduce/courses',
            name:'IntroduceCourses'
          },
          {
            title:'PositionOpening',
            url:'/introduce/positionOpening',
            name:'IntroducePositionOpening'
          },
          {
            title:'ContactInformation',
            url:'/introduce/contactInformation',
            name:'IntroduceContactInformation'
          },] -->



// WEBPACK FOOTER //
// src/layout/sideBar.vue